import {
  Avatar,
  Box,
  LinearProgress,
  ListItem,
  ListItemAvatar,
  ListItemText,
} from "@mui/material";
import { t } from "i18next";
import AssignmentIndRoundedIcon from "@mui/icons-material/AssignmentIndRounded";
type AuthorCountComponentProps = {
  name: string;
  source: string;
  count: number;
  scaledNumber: number;
  color?:
    | "primary"
    | "secondary"
    | "error"
    | "info"
    | "success"
    | "warning"
    | "inherit";
};

export default function AuthorCountComponent(props: AuthorCountComponentProps) {
  return (
    <ListItem>
      <ListItemAvatar>
        <Avatar
          style={{
            background: "none",
            width: "24px",
            height: "24px",
            margin: "auto",
          }}
        >
          <AssignmentIndRoundedIcon color="info"/>
        </Avatar>
      </ListItemAvatar>
      <ListItemText
        primary={props.name}
        primaryTypographyProps={{
          fontSize: "14px",
        }}
        secondary={
          t("author:article_counts") + ": " + Math.round(props.count)
        }
        secondaryTypographyProps={{ fontSize: "13px" }}
      ></ListItemText>
      <Box sx={{ width: "40%", marginRight: "20px" }}>
        <LinearProgress
          variant="determinate"
          color={props.color ? props.color : "success"}
          value={props.scaledNumber * 100}
        />
      </Box>
    </ListItem>
  );
}
